import { makeStyles } from '@material-ui/core/styles'
import CustomField from './CustomField'
import FormikField from '../../../1elements/Fields/FormikField'
import { Text } from '../../../1elements'
import DateField from '../../../1elements/Fields/DateField'
import { placeholder } from '../../../../consts/placeholder'
import AddressFieldsLine from '../../../2compounds/CompoundsFields/AddressFieldsLine'

const EditItem = ({ item, index, fieldIndex }) => {
  const classes = useStyles()
  const { label, type, fieldId } = item
  const dataType = type ? type.toLowerCase() : ''
  const name = `values[${index}].cardData[${fieldIndex}].fieldData`
  switch (dataType) {
    case 'shorttext':
    case 'text':
      return (
        <CustomField item={item} name={name}>
          <FormikField
            name={name}
            className={classes.textField}
            placeholder={placeholder.text}
            type={dataType}
          />
        </CustomField>
      )
    case 'number':
      return (
        <div className={classes.itemRow}>
          <Text type={'h9'} className={classes.label}>
            {label} :<span>&nbsp;</span>
          </Text>
          <FormikField
            name={name}
            className={classes.textField}
            placeholder={placeholder.number}
            type={dataType}
            errorRef={fieldId}
          />
        </div>
      )
    case 'location':
      return (
        <div className={classes.itemRow}>
          <AddressFieldsLine cardIndex={index} fieldIndex={fieldIndex} />
        </div>
      )
    case 'date':
      return (
        <div className={classes.itemRow}>
          <Text type={'h9'} className={classes.label}>
            {label} :<span>&nbsp;</span>
          </Text>
          <DateField name={name} className={classes.textField} />
        </div>
      )
    case 'link':
      return (
        <CustomField item={item} name={name}>
          <FormikField
            name={name}
            placeholder={placeholder.link}
            className={classes.textField}
            type={dataType}
            errorRef={fieldId}
          />
        </CustomField>
      )
    default:
      return (
        <div className={classes.itemRow}>
          <Text type={'h9'} className={classes.label}>
            {label} :<span>&nbsp;</span>
          </Text>
          <FormikField
            name={name}
            className={classes.textField}
            placeholder={placeholder.text}
            type={dataType}
            errorRef={fieldId}
          />
        </div>
      )
  }
}

export default EditItem

const useStyles = makeStyles({
  textField: {
    width: '60%',

    '& .MuiInputBase-input': {
      boxShadow: '0px 3px 6px #00000029',
      padding: '1px 3px'
    }
  },
  itemRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 0',
    maxWidth: '100%',
    width: '100%'
  },
  label: {
    whiteSpace: 'nowrap'
  }
})
